import plans from '@mssgme/plans';

// TODO: remove, @mssgme/plans will be remove in the future
export default (value, format, locale) => {
    if (format === 'plan') {
        return plans[value] ? plans[value].name : (value || '').toUpperCase();
    }
};
